import { Component, OnInit } from '@angular/core';
import { EcosistemasService } from 'src/app/services/ecosistemas.service';

@Component({
  selector: 'app-info-panel',
  templateUrl: './info-panel.component.html',
  styleUrls: ['./info-panel.component.scss']
})
export class InfoPanelComponent implements OnInit {

  arrinfo: any[];
  toggle_info: boolean;
  listaElementos: any[] = [];

  constructor(
    public ecosistemaService: EcosistemasService
  ) {
    this.listaElementos.push({
      posx: 0,
      posy: 0,
    });
    this.ecosistemaService.buttonStateChanged.subscribe((event: { buttonName: string, newState: boolean }) => {
      if (event.buttonName === 'toggle_info') {
        this.toggle_info = event.newState;
      }
    });
    this.ecosistemaService.arr_info$.subscribe( info_array =>{
      this.arrinfo = info_array;
    })
  }

  ngOnInit(){
    this.arrinfo = []
    this.toggle_info = true;
  }

}
